import { Stack, Avatar, Paper, Portal, Popper } from "@mui/material";
import { User } from "../../../../users-admin/types/User";
import { AssigneeDetails } from "./AssigneeDetails";
import { Ref, RefObject, useEffect, useRef, useState } from "react";
import { set } from "date-fns";

interface Props {
  assignees: User[];
}

export const TableRowAssignees: React.FC<Props> = ({ assignees }) => {
  const [assigneeDetailsOpen, setAssigneeDetailsOpen] = useState(false);
  const stackRef = useRef<HTMLDivElement | null>(null);
  const paperRef = useRef<HTMLDivElement | null>(null);

  console.log(assignees);

  useEffect(() => {
    if (!stackRef && !paperRef) return;

    if (!stackRef.current && !paperRef.current) return;

    const displayPaperView = () => {
      setAssigneeDetailsOpen(true);
    };

    const hidePaperView = () => {
      setAssigneeDetailsOpen(false);
    };

    if (stackRef.current) {
      stackRef.current.addEventListener("mouseenter", displayPaperView);
      stackRef.current.addEventListener("mouseleave", hidePaperView);
    }

    return () => {
      if (stackRef.current) {
        stackRef.current.removeEventListener("mouseenter", displayPaperView);
        stackRef.current.removeEventListener("mouseleave", hidePaperView);
      }
    };
  }, []);
  return (
    <>
      <Stack
        ref={stackRef}
        direction={"row"}
        gap={"-2"}
        sx={{ cursor: "pointer", mt: 2 }}
      >
        {assignees.slice(0, 3).map((assignee, index) => {
          return (
            <Avatar
              alt="user picture"
              sx={{
                width: 25,
                height: 25,
                border: "1px solid #fff",
                position: index > 0 ? "relative" : "static", // allowing avatars to overlay
                left: index === 0 ? 0 : -10 * index, // allowing avatars to overlay
              }}
              src={assignee.first_name.charAt(0).toUpperCase()}
            ></Avatar>
          );
        })}
      </Stack>
      <Popper
        open={assigneeDetailsOpen}
        anchorEl={stackRef.current}
        placement="left-end"
        style={{
          zIndex: 1,
          backgroundColor: "white",
        }}
      >
        <Paper
          style={{
            //width: "",
            position: "absolute",
            zIndex: 100,
            padding: 5,
            left: "-38px",
            width: "180px",
            // backgroundColor: "white",
          }}
        >
          {assignees.map((assignee, index) => {
            return (
              <AssigneeDetails
                key={index}
                firstName={assignee.email.split("@")[0]}
                lastName=""
                profileImg={null}
              />
            );
          })}
        </Paper>
      </Popper>
    </>
  );
};
